// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"BanksGroup-module__partnersContainer","banksCont":"BanksGroup-module__banksCont","partnersButton":"BanksGroup-module__partnersButton"};